module.exports = __webpack_public_path__ + "static/img/rppghealthapp3.b8e34c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/rppghealthapp3.png
// module id = mSSQ
// module chunks = 5